import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Icon from './Icon';

class Expander extends PureComponent {
  render() {
    const { isExpanded, activeColumns, onClick } = this.props;
    const isMaxEnabledMetricsReached = Object.keys(activeColumns).reduce((res, key) => res += Number(activeColumns[key]), 0) > 9;

    const className = [
      'expander',
      isMaxEnabledMetricsReached ? 'blinking': '',
      isExpanded ? 'active' : '',
    ].join(' ');
    
    const icon = isExpanded
      ? 'close'
      : 'expand';

    return (
      <div
        className={className}
        onClick={onClick}
      >
        <Icon img={icon} />
      </div>
    );
  }
}

Expander.propTypes = {
  /**
   * Columns statuses
   */
  activeColumns: PropTypes.object,

  /**
   * Name of icon
   */
  isExpanded: PropTypes.bool.isRequired,

  /**
   * Click handler
   */
  onClick: PropTypes.func.isRequired,
}

export default Expander;
